globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Modals = appCustomerSpace.Modals || {};
appCustomerSpace.Modals.Settings = appCustomerSpace.Modals.Settings || {};

appCustomerSpace.Modals.Settings.ContactEdit = (function(superClass) {

  utils.extend(ContactEdit, superClass);

  function ContactEdit() {
    return ContactEdit.__super__.constructor.apply(this, arguments);
  }

  $.extend(ContactEdit.prototype, {
    init: function() {
      this._initAccordion();

      return ContactEdit.__super__.init.apply(this, arguments);
    },

    _initAccordion: function () {
      if ($(".accordion").length == 0)
        return
      var _this = this;
      var options = {
        collapsible: true,
        heightStyle: "content",
        animate: 200,
        active: false,
      };
      $accordion = $(".accordion");
      $accordion.first().accordion(options);
      _this._refreshAccordion();
      $(window).resize(function () {
        _this._refreshAccordion();
      });
    },

    _refreshAccordion: function () {
      if ($(".accordion").length == 0)
        return
      var $accordion = $(".accordion");

      var $content = $accordion.find('.ui-accordion-content'),
        windowHeight = $(window).height(),
        accordionTop = $accordion.offset().top,
        $buttons = $accordion.find('h5'),
        heightTotalButtons = $buttons[0].offsetHeight * $buttons.length,
        heightMax = windowHeight - accordionTop - heightTotalButtons;

      $content.css({
        height: "100%",
        overflowY: 'auto'
      });
    },

    callbackSuccess: function(data) {
      var controller = this;

      controller.$form = this.$html.find('form').first();
      if (!data.response) {
        appCustomerSpace.LimitlessPlugins.Validation.errors({ $form: controller.$form, errors: JSON.parse(data.errors), prepend_field_name: 'customer_space_crm_contact' });
        appCustomerSpace.Loader().stop();
      } else {
        ContactEdit.__super__.callbackSuccess.apply(this, arguments);
      }
    },
    updateView: function(response) {
      if (this.subModal() != undefined) {
        this.subModal().$html.find('.modal-content').replaceWith($(response.html).find('.modal-content'));
      }
      if (response.contact_title_html) {
        $(`.contact-title-${response.contact_uniq_key}`).replaceWith($(response.contact_title_html));
      }
      if (response.contact_email_status_html) {
        $(`.contact-email-status-badge-${response.contact_uniq_key}`).replaceWith($(response.contact_email_status_html));
      }
      if (response.deliveries_html) {
        $("#deliveries-table").replaceWith($(response.deliveries_html));
      }
    }
  });

  return ContactEdit;

})(appCustomerSpace.Modal);
